import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Checkbox,
  FormControlLabel,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";

const SearchDrawer = (props) => {
  const { label, checkboxesData, checkboxHandler } = props;

  const [showAll, setShowAll] = useState(false);
  // State to keep track of the number of checked checkboxes
  const [checkedCount, setCheckedCount] = useState(0);

  const handleCheckboxChange = (event, index, checkbox) => {
    const isChecked = event.target.checked;
    // setCheckedCount((prevCount) => (isChecked ? prevCount + 1 : prevCount - 1));
    console.log(checkbox);
    if (isChecked) {
      checkbox["checked"] = true;
    } else {
      checkbox["checked"] = false;
    }
    checkboxHandler(index, checkbox);
  };

  // how many checkboxes to show
  let visibleCheckboxes = [];

  if (checkboxesData?.length > 0) {
    visibleCheckboxes = showAll ? checkboxesData : checkboxesData.slice(0, 6);
  }

  return (
    <Accordion
      defaultExpanded
      sx={{
        boxShadow: "none !important",
        minWidth: "90%",
        // background: 'red',
        "& .MuiButtonBase-root.MuiAccordionSummary-root ": {
          minHeight: "auto !important",
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          "& .MuiAccordionSummary-content": {
            margin: "0 !important",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          },
        }}
      >
        <Typography sx={{ margin: "0", fontSize: "20px" }}>{label}</Typography>
        {/* {checkedCount > 0 && (
          <Box
            sx={{
              height: "20px",
              width: "22px",
              color: "#FFFFFF",
              background: "#E63946",
              textAlign: "center",
              borderRadius: "50%",
            }}
          >
            {checkedCount}
          </Box>
        )} */}
      </AccordionSummary>
      <AccordionDetails>
        <div
          style={{
            marginTop: "14px !important",
            display: "flex",
            flexDirection: "column",
            gap: "12px !important",
          }}
        >
          {visibleCheckboxes.map((checkbox, index) => (
            <FormControlLabel
              key={checkbox.id}
              checked={checkbox.checked}
              control={
                <Checkbox
                  onChange={(event) =>
                    handleCheckboxChange(event, index, checkbox)
                  }
                />
              }
              label={checkbox.label}
              sx={{
                "&.MuiFormControlLabel-root": {
                  margin: "0px !important",
                  gap: "8px !important",
                },
              }}
            />
          ))}
          {!showAll && checkboxesData.length > 6 && (
            <Typography
              variant="body2"
              color="primary"
              style={{
                cursor: "pointer",
                marginTop: 8,
                color: "#004FE0",
                fontWeight: "600",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => setShowAll(true)}
            >
              Show More
              <KeyboardArrowDownRoundedIcon />
            </Typography>
          )}
          {showAll && (
            <Typography
              variant="body2"
              color="primary"
              style={{
                cursor: "pointer",
                marginTop: 8,
                color: "#004FE0",
                fontWeight: "600",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => setShowAll(false)}
            >
              Show Less
              <KeyboardArrowUpRoundedIcon />
            </Typography>
          )}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default SearchDrawer;
